module.exports = __webpack_public_path__ + "media/images/ui__infoOk-5f358056a866722179d935fa6650d810.png";